<template>
  <v-dialog v-model="dialog" max-width="400">
    <v-card>
      <v-card-title class="text-subtitle-1 font-weight-bold"
        >Update account number</v-card-title
      >
      <v-card-subtitle class="text--secondary pt-2"
        >Update the customer's account number here</v-card-subtitle
      >
      <v-card-text class="mt-2">
        <ValidationObserver ref="observer">
          <ValidationProvider
            name="Account number"
            rules="required|unique_account_number_check"
            events="['blur']"
            v-slot="{ errors }"
          >
            <v-text-field
              dense
              outlined
              label="Account number*"
              :error-messages="errors"
              v-model="accountNumber"
            ></v-text-field>
          </ValidationProvider>
        </ValidationObserver>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="close" depressed>Cancel</v-btn>
        <v-btn @click="submit" depressed color="primary">Update</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import pageMixin from '@/mixins/page.mixin';
import { extend } from 'vee-validate';

import AccountManagementService from '@/modules/loanpro/services/account-management.service';
const accountManagementService = new AccountManagementService();
export default {
  mixins: [pageMixin],
  data() {
    return {
      accountId: '',
      accountNumber: '',
      dialog: false
    };
  },
  emits: ['update'],
  mounted(){
    extend("unique_account_number_check", {
      validate: async value => {
          const result = await accountManagementService.doesAccountNumberExist(this.accountId, value);
          if (!result) {
            return true;
          }

        return {
          valid: false,
        };
      },
      message: "This account number already exist."
    });
  },
  methods: {
    open(accountId, value) {
      this.dialog = true;
      this.accountId = accountId;
      this.accountNumber = value;
    },
    close() {
      this.accountNumber = '';
      this.$refs.observer?.reset();
      this.dialog = false;
    },
    async submit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      this.$emit('update', this.accountNumber);
      this.close();
    }
  }
};
</script>
